import decodeUrlQuery from '@jetshop/core/helpers/decodeUrlQuery';
import qs from 'qs';
import { peekVariant, getMissingOptions } from './ProductVariationProvider';
/** Parses the `att` query parameter for base64-encoded variant values separated by a pipe `|` */
export function getDefaultValuesFromUrl(product, location) {
    const { search } = location;
    const urlQuery = qs.parse(search, { ignoreQueryPrefix: true });
    if (!urlQuery || !urlQuery.att)
        return {};
    const decodedUrlQuery = decodeUrlQuery({
        urlQuery,
        parametersToBeDecoded: ['att']
    });
    const urlQueryValues = decodedUrlQuery.att.split('|');
    const variantOptions = product.variants.options;
    // If there are more or less variants options are provided then do not set default values
    if (variantOptions.length !== urlQueryValues.length)
        return {};
    const selectedOptions = {};
    for (let x = 0; x < variantOptions.length; x++) {
        const { name } = variantOptions[x];
        // If even one value is incorrect, we don't set any of the values
        if (!variantOptions[x].values.includes(urlQueryValues[x]))
            return {};
        selectedOptions[name] = urlQueryValues[x];
    }
    const selectedVariation = peekVariant(product, selectedOptions);
    const hasMissingOption = getMissingOptions(product, selectedOptions).length !== 0;
    const selectedVariationProps = {
        selectedOptions,
        missingOption: null,
        hasMissingOption,
        selectedVariation
    };
    return selectedVariationProps;
}
//# sourceMappingURL=getDefaultValuesFromUrl.js.map